import React, { useContext, useEffect, useState } from "react";
import ConfiguratorSurveyOutput from "./ConfiguratorSurveyOutput";
import { FormattedMessage } from "react-intl";
import filterActiveSteps from "../utils/filterActiveSteps";
import TranslatedKey from "./TranslatedKey";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import ConfiguratorContext from "./ConfiguratorContext";
import AuthenticationService from "../services/AuthenticationService";

const RealTimeOutputStep = ({ step, isActive, role }) => {
  const [active, setActive] = useState(!!isActive);

  useEffect(() => {
    setActive(isActive);
  }, [isActive]);

  const hidden = step.hidden_question.includes(`role_type_${role}`)
    ? "hidden"
    : "";

  return (
    <div className={`w-full border-b py-4 border-black ${hidden}`}>
      <div
        className="flex justify-between cursor-pointer "
        onClick={() => {
          setActive(!active);
        }}
      >
        <div style={{ maxWidth: "85%" }}>
          <h2 className="text-xl leading-none">
            <TranslatedKey id={step.title || step.name || `Step ${step.id}`} />
          </h2>
        </div>
        <div className="w-7 h-7 cursor-pointer">
          {active ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </div>
      </div>
      {active && step.blocks?.length ? (
        <div className="mt-4">
          {step.blocks.map((output, index) => (
            <ConfiguratorSurveyOutput
              key={`${output.id}-${index}`}
              output={output}
              role={role}
              realtime
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

const ConfiguratorSurveyRealTimeSummary = ({ activeStep, role }) => {
  const context = useContext(ConfiguratorContext);
  const activeSteps = filterActiveSteps(context);
  const userData = AuthenticationService.getUserData();

  return (
    <div
      className={`w-full lg:w-1/3 lg:mt-0 bg-${userData.business}-400 py-8 px-6`}
    >
      <div className="sticky top-0">
        <h2 className="text-2xl mb-4 text-center uppercase">
          <FormattedMessage id="summary" defaultMessage="Summary" />
        </h2>

        {activeSteps
          .filter((step) => step.blocks.length)
          .filter((i) => !i.hidden_question.includes(`role_type_${role}`))
          .map((step, index) => (
            <RealTimeOutputStep
              key={`${step.id}-${index}`}
              step={step}
              isActive={step.id === activeStep.id}
              role={role}
            />
          ))}
      </div>
    </div>
  );
};

export default ConfiguratorSurveyRealTimeSummary;
